export default "__VITE_ASSET__DDUtuARQ__"